<template>
  <transition name="fade">
    <div class="loading" v-show="$store.state.app.loading">
      <Loading color="#1989fa" />
    </div>
  </transition>
</template>

<script>
import { Loading } from 'vant'

export default {
  components: { Loading },
}
</script>
<style lang="less" scoped>
.loading {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>